// // // // // import React, { useState, useEffect } from "react";
// // // // // import { useLocation, useNavigate } from "react-router-dom";
// // // // // import { toast, ToastContainer } from "react-toastify";
// // // // // import "react-toastify/dist/ReactToastify.css";

// // // // // const Updatefares = () => {
// // // // //   const location = useLocation();
// // // // //   const navigate = useNavigate();
// // // // //   const initialData = location.state?.responseData || {};
// // // // //   const [editableData, setEditableData] = useState(initialData);

// // // // //   useEffect(() => {
// // // // //     console.log("Received Data for Update:", editableData);
// // // // //   }, [editableData]);

// // // // //   const handleInputChange = (e) => {
// // // // //     const { name, value } = e.target;
// // // // //     setEditableData((prevData) => ({ ...prevData, [name]: value }));
// // // // //   };

// // // // //   const handleSaveChanges = async () => {
// // // // //     if (!editableData.ID || !editableData.PackageName) {
// // // // //       toast.warn("ID and Package Name are required.");
// // // // //       return;
// // // // //     }

// // // // //     const whereCondition = `ID=${editableData.ID}`;

// // // // //     const updateData = new URLSearchParams({
// // // // //       SecurityKey: "abcd",
// // // // //       TableName: "Fares",
// // // // //       WhereCondition: whereCondition,
// // // // //     });

// // // // //     Object.entries(editableData).forEach(([key, value]) => {
// // // // //       if (value !== undefined && value !== null && key !== "ID") {
// // // // //         updateData.append(key.trim(), value.toString());
// // // // //       }
// // // // //     });

// // // // //     try {
// // // // //       const response = await fetch(
// // // // //         "http://etour.responseinfoway.com/restapi/updatedata.aspx",
// // // // //         {
// // // // //           method: "POST",
// // // // //           headers: {
// // // // //             "Content-Type": "application/x-www-form-urlencoded",
// // // // //             Accept: "application/json",
// // // // //           },
// // // // //           body: updateData.toString(),
// // // // //         }
// // // // //       );

// // // // //       const textResponse = await response.text();
// // // // //       console.log("Raw Response:", textResponse);

// // // // //       let jsonResponse;
// // // // //       try {
// // // // //         jsonResponse = JSON.parse(textResponse);
// // // // //       } catch {
// // // // //         toast.success("Update successful.");
// // // // //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // // //         return;
// // // // //       }

// // // // //       if (jsonResponse?.Response?.[0]?.Status === "Ok") {
// // // // //         toast.success("Data updated successfully!");
// // // // //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // // //       } else {
// // // // //         toast.error(
// // // // //           "Update failed: " + (jsonResponse.message || "Unknown error")
// // // // //         );
// // // // //       }
// // // // //     } catch (error) {
// // // // //       console.error("Error:", error);
// // // // //       toast.error("Network or server error!");
// // // // //     }
// // // // //   };

// // // // //   return (
// // // // //     <div className="update-container mb-5">
// // // // //       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
// // // // //       <h1>🔄 Update Fares</h1>

// // // // //       <form>
// // // // //         <div className="input-group d-none">
// // // // //           <input type="text" name="ID" value={editableData.ID || ""} readOnly />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Package Name</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="PackageName"
// // // // //             value={editableData.PackageName || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Base Fare</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="BaseFare"
// // // // //             value={editableData.BaseFare || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Fuel Rate KM</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="FuelRateKM"
// // // // //             value={editableData.FuelRateKM || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Lub Rate KM</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="LubRateKM"
// // // // //             value={editableData.LubRateKM || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Time Rate Per Minute</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="TimeRatePM"
// // // // //             value={editableData.TimeRatePM || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Included KM</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="IncludedKM"
// // // // //             value={editableData.IncludedKM || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Included Hours</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="IncludedHrs"
// // // // //             value={editableData.IncludedHrs || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Vehicle Type</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="Vtype"
// // // // //             value={editableData.Vtype || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <button type="button" className="save-changebtn" onClick={handleSaveChanges}>
// // // // //           ✅ Save Changes
// // // // //         </button>
// // // // //       </form>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default Updatefares;




// // // // // import React, { useState, useEffect } from "react";
// // // // // import { useLocation, useNavigate } from "react-router-dom";
// // // // // import { toast, ToastContainer } from "react-toastify";
// // // // // import "react-toastify/dist/ReactToastify.css";
// // // // // import { SECURITY_KEY } from "../../../globals";

// // // // // const Updatefares = () => {
// // // // //   const location = useLocation();
// // // // //   const navigate = useNavigate();
// // // // //   const initialData = location.state?.responseData || {};
// // // // //   const [editableData, setEditableData] = useState(initialData);
// // // // //   const [vehicleTypeList, setVehicleTypeList] = useState([]);
// // // // //   const [loading, setLoading] = useState(false);
// // // // //   const [error, setError] = useState(null);

// // // // //   useEffect(() => {
// // // // //     console.log("Received Data for Update:", editableData);
// // // // //   }, [editableData]);

// // // // //   useEffect(() => {
// // // // //     fetchVehicleTypes();
// // // // //   }, []);

// // // // //   const fetchVehicleTypes = async () => {
// // // // //     setError(null);
// // // // //     setLoading(true);
// // // // //     setVehicleTypeList([]);

// // // // //     const data = new URLSearchParams();
// // // // //     // data.append("SecurityKey", "abcd");
// // // // //     data.append("SecurityKey", SECURITY_KEY);
// // // // //     data.append("TableName", "VehicleTypes");
// // // // //     data.append("WhereCondition", "All");
// // // // //     data.append("*", "*");

// // // // //     try {
// // // // //       // const proxyUrl = "https://thingproxy.freeboard.io/fetch/";
// // // // //       const apiUrl = "https://etour.responseinfoway.com/restapi/Selectdata.aspx";

// // // // //       const response = await fetch(apiUrl, {
// // // // //         method: "POST",
// // // // //         headers: {
// // // // //           "Content-Type": "application/x-www-form-urlencoded",
// // // // //         },
// // // // //         body: data.toString(),
// // // // //       });

// // // // //       const textData = await response.text(); // ✅ Get raw text
// // // // //       console.log("Vehicle Type API Raw Response:", textData);

// // // // //       let jsonData;
// // // // //       try {
// // // // //         jsonData = JSON.parse(textData); // ✅ Parse JSON manually
// // // // //       } catch (err) {
// // // // //         console.error("Vehicle Type JSON Parse Error:", err);
// // // // //         jsonData = null;
// // // // //       }

// // // // //       if (jsonData && Array.isArray(jsonData.Response)) {
// // // // //         setVehicleTypeList(jsonData.Response);
// // // // //       } else {
// // // // //         setError("No vehicle type data found.");
// // // // //       }
// // // // //     } catch (error) {
// // // // //       console.error("Vehicle Type Fetch Error:", error);
// // // // //       setError("Failed to fetch vehicle types.");
// // // // //     } finally {
// // // // //       setLoading(false);
// // // // //     }
// // // // // };


// // // // //   const handleInputChange = (e) => {
// // // // //     const { name, value } = e.target;

// // // // //     if (name === "Vtype") {
// // // // //       console.log("Selected Vehicle Type ID:", value);
// // // // //     }

// // // // //     setEditableData((prevData) => ({ ...prevData, [name]: value }));
// // // // //   };

// // // // //   const handleSaveChanges = async () => {
// // // // //   if (!editableData.ID || !editableData.PackageName) {
// // // // //     toast.warn("ID and Package Name are required.");
// // // // //     return;
// // // // //   }

// // // // //   const whereCondition = `ID=${editableData.ID}`;

// // // // //   const updateData = new URLSearchParams({
// // // // //     SecurityKey: SECURITY_KEY,
// // // // //     TableName: "Fares",
// // // // //     WhereCondition: whereCondition,
// // // // //   });

// // // // //   Object.entries(editableData).forEach(([key, value]) => {
// // // // //     if (value !== undefined && value !== null && key !== "ID") {
// // // // //       updateData.append(key.trim(), value.toString());
// // // // //     }
// // // // //   });

// // // // //   try {
// // // // //     const response = await fetch(
// // // // //       "https://etour.responseinfoway.com/restapi/updatedata.aspx",
// // // // //       {
// // // // //         method: "POST",
// // // // //         headers: {
// // // // //           "Content-Type": "application/x-www-form-urlencoded",
// // // // //           Accept: "application/json",
// // // // //         },
// // // // //         body: updateData.toString(),
// // // // //       }
// // // // //     );

// // // // //     const textResponse = await response.text();
// // // // //     console.log("Updated Data API Response:", textResponse);

// // // // //     // ✅ Check for success keywords in plain text response
// // // // //     if (
// // // // //       textResponse.toLowerCase().includes("deleted") ||
// // // // //       textResponse.toLowerCase().includes("success") ||
// // // // //       textResponse.toLowerCase().includes("ok")
// // // // //     ) {
// // // // //       toast.success(textResponse); // show actual server success message
// // // // //       setTimeout(() => {
// // // // //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // // //       }, 1500); // wait for toast to show before redirect
// // // // //       return;
// // // // //     }

// // // // //     // ✅ If JSON is returned
// // // // //     let jsonResponse;
// // // // //     try {
// // // // //       jsonResponse = JSON.parse(textResponse);
// // // // //     } catch {
// // // // //       toast.success("Update successful.");
// // // // //       setTimeout(() => {
// // // // //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // // //       }, 1500);
// // // // //       return;
// // // // //     }

// // // // //     if (jsonResponse?.Response?.[0]?.Status === "Ok") {
// // // // //       toast.success("Data updated successfully!");
// // // // //       setTimeout(() => {
// // // // //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // // //       }, 1500);
// // // // //     } else {
// // // // //       toast.error("Update failed: " + (jsonResponse.message || "Unknown error"));
// // // // //     }
// // // // //   } catch (error) {
// // // // //     console.error("Update Error:", error);
// // // // //     toast.error("Update failed due to network or server error.");
// // // // //   }
// // // // // };


// // // // //   return (
// // // // //     <div className="update-container mb-5">
// // // // //       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
// // // // //       <h1>🔄 Update Fares</h1>

// // // // //       <form>
// // // // //         <div className="input-group d-none">
// // // // //           <input type="text" name="ID" value={editableData.ID || ""} readOnly />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Package Name</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="PackageName"
// // // // //             value={editableData.PackageName || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Base Fare</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="BaseFare"
// // // // //             value={editableData.BaseFare || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Fuel Rate KM</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="FuelRateKM"
// // // // //             value={editableData.FuelRateKM || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Lub Rate KM</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="LubRateKM"
// // // // //             value={editableData.LubRateKM || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Time Rate Per Minute</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="TimeRatePM"
// // // // //             value={editableData.TimeRatePM || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Included KM</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="IncludedKM"
// // // // //             value={editableData.IncludedKM || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group">
// // // // //           <label>Included Hours</label>
// // // // //           <input
// // // // //             type="text"
// // // // //             name="IncludedHrs"
// // // // //             value={editableData.IncludedHrs || ""}
// // // // //             onChange={handleInputChange}
// // // // //           />
// // // // //         </div>

// // // // //         <div className="input-group_select">
// // // // //           <label>Vehicle Type</label>
// // // // //           <select
// // // // //             name="Vtype"
// // // // //             value={editableData.Vtype?.toString() || ""}
// // // // //             onChange={handleInputChange}
// // // // //             required
// // // // //           >
// // // // //             <option value="">Select Vehicle Type</option>
// // // // //             {vehicleTypeList.map((type) => (
// // // // //               <option key={type.ID} value={type.ID}>
// // // // //                 {type.VTYPE}
// // // // //               </option>
// // // // //             ))}
// // // // //           </select>
// // // // //         </div>

// // // // //         <button type="button" className="save-changebtn" onClick={handleSaveChanges}>
// // // // //           Save Changes
// // // // //         </button>
// // // // //       </form>
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default Updatefares;






// // // // import React, { useState, useEffect } from "react";
// // // // import { useLocation, useNavigate } from "react-router-dom";
// // // // import { toast, ToastContainer } from "react-toastify";
// // // // import "react-toastify/dist/ReactToastify.css";
// // // // import { SECURITY_KEY } from "../../../globals";
// // // // import { apiWithLog } from "../../../utils/apiWithLog";

// // // // const Updatefares = () => {
// // // //   const location = useLocation();
// // // //   const navigate = useNavigate();
// // // //   const initialData = location.state?.responseData || {};
// // // //   const [editableData, setEditableData] = useState(initialData);
// // // //   const [vehicleTypeList, setVehicleTypeList] = useState([]);
// // // //   const [loading, setLoading] = useState(false);
// // // //   const [error, setError] = useState(null);

// // // //   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
// // // //   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

// // // //   const [existingFaresList, setExistingFaresList] = useState([]);
// // // //   const [packageNamesList, setPackageNamesList] = useState([]);
// // // //   const [isCustomPackage, setIsCustomPackage] = useState(false);

// // // //   // ✅ Fetch vehicle types and existing fares on mount
// // // //   useEffect(() => {
// // // //     fetchVehicleTypes();
// // // //     fetchExistingFares();
// // // //   }, []);

// // // //   const fetchExistingFares = async () => {
// // // //     try {
// // // //       const compID = editableData.CompID || JSON.parse(localStorage.getItem("selectedCompany"))?.id;
// // // //       const data = new URLSearchParams();
// // // //       data.append("SecurityKey", SECURITY_KEY);
// // // //       data.append("TableName", "Fares");
// // // //       data.append("WhereCondition", compID ? `CompID=${compID}` : "All");
// // // //       data.append("*", "*");

// // // //       const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
// // // //       const response = await fetch(apiUrl, {
// // // //         method: "POST",
// // // //         headers: { "Content-Type": "application/x-www-form-urlencoded" },
// // // //         body: data.toString(),
// // // //       });

// // // //       const jsonData = await response.json();
// // // //       if (Array.isArray(jsonData.Response)) {
// // // //         setExistingFaresList(jsonData.Response);
// // // //         const uniqueNames = Array.from(
// // // //           new Set(
// // // //             jsonData.Response.map((f) => (f.PackageName || "").trim()).filter(Boolean)
// // // //           )
// // // //         ).sort();
// // // //         setPackageNamesList(uniqueNames);
// // // //       } else {
// // // //         setExistingFaresList([]);
// // // //         setPackageNamesList([]);
// // // //       }
// // // //     } catch (err) {
// // // //       console.error("Failed to fetch existing fares:", err);
// // // //     }
// // // //   };

// // // //   const handlePackageSelect = (e) => {
// // // //     const selectedName = e.target.value;
// // // //     if (selectedName === "__ADD_NEW__") {
// // // //       setIsCustomPackage(true);
// // // //       setEditableData((prev) => ({ ...prev, PackageName: "" }));
// // // //       return;
// // // //     }

// // // //     const matchingFare = existingFaresList.find(
// // // //       (f) => (f.PackageName || "").trim().toLowerCase() === selectedName.toLowerCase()
// // // //     );

// // // //     setEditableData((prev) => ({
// // // //       ...prev,
// // // //       PackageName: selectedName,
// // // //       BaseFare: matchingFare?.BaseFare != null ? matchingFare.BaseFare : prev.BaseFare,
// // // //       FuelRateKM: matchingFare?.FuelRateKM != null ? matchingFare.FuelRateKM : prev.FuelRateKM,
// // // //       LubRateKM: matchingFare?.LubRateKM != null ? matchingFare.LubRateKM : prev.LubRateKM,
// // // //       TimeRatePM: matchingFare?.TimeRatePM != null ? matchingFare.TimeRatePM : prev.TimeRatePM,
// // // //       IncludedKM: matchingFare?.IncludedKM != null ? matchingFare.IncludedKM : prev.IncludedKM,
// // // //       IncludedHrs: matchingFare?.IncludedHrs != null ? matchingFare.IncludedHrs : prev.IncludedHrs,
// // // //     }));
// // // //   };

// // // //   const fetchVehicleTypes = async () => {
// // // //     setError(null);
// // // //     setLoading(true);
// // // //     setVehicleTypeList([]);

// // // //     const data = new URLSearchParams();
// // // //     data.append("SecurityKey", SECURITY_KEY);
// // // //     data.append("TableName", "VehicleTypes");
// // // //     data.append("WhereCondition", "All");
// // // //     data.append("*", "*");

// // // //     try {
// // // //       const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
// // // //       const response = await fetch(apiUrl, {
// // // //         method: "POST",
// // // //         headers: { "Content-Type": "application/x-www-form-urlencoded" },
// // // //         body: data.toString(),
// // // //       });

// // // //       const textData = await response.text();
// // // //       console.log("Vehicle Type API Raw Response:", textData);

// // // //       let jsonData;
// // // //       try {
// // // //         jsonData = JSON.parse(textData);
// // // //       } catch (err) {
// // // //         console.error("JSON Parse Error:", err);
// // // //         jsonData = null;
// // // //       }

// // // //       if (jsonData && Array.isArray(jsonData.Response)) {
// // // //         setVehicleTypeList(jsonData.Response);
// // // //       } else {
// // // //         setError("No vehicle type data found.");
// // // //       }
// // // //     } catch (error) {
// // // //       console.error("Vehicle Type Fetch Error:", error);
// // // //       setError("Failed to fetch vehicle types.");
// // // //     } finally {
// // // //       setLoading(false);
// // // //     }
// // // //   };

// // // //   const handleInputChange = (e) => {
// // // //     const { name, value } = e.target;
// // // //     setEditableData((prev) => ({ ...prev, [name]: value }));
// // // //   };

// // // //   // const handleSaveChanges = async () => {
// // // //   //   if (!editableData.ID || !editableData.PackageName) {
// // // //   //     toast.warn("ID and Package Name are required.");
// // // //   //     return;
// // // //   //   }

// // // //   //   const whereCondition = `ID=${editableData.ID}`;
// // // //   //   const updateData = new URLSearchParams({
// // // //   //     SecurityKey: SECURITY_KEY,
// // // //   //     TableName: "Fares",
// // // //   //     WhereCondition: whereCondition,
// // // //   //   });

// // // //   //   Object.entries(editableData).forEach(([key, value]) => {
// // // //   //     if (value !== undefined && value !== null && key !== "ID") {
// // // //   //       updateData.append(key.trim(), value.toString());
// // // //   //     }
// // // //   //   });

// // // //   //   try {
// // // //   //     const response = await fetch(
// // // //   //       // "https://etour.responseinfoway.com/restapi/updatedata.aspx",
// // // //   //       // "https://etourrestapi.responseinfoway.com/restApi/updatedata.aspx",
// // // //   //       `${BASE_REST_API_URL}/updatedata.aspx`,
// // // //   //       {
// // // //   //         method: "POST",
// // // //   //         headers: {
// // // //   //           "Content-Type": "application/x-www-form-urlencoded",
// // // //   //           Accept: "application/json",
// // // //   //         },
// // // //   //         body: updateData.toString(),
// // // //   //       }
// // // //   //     );

// // // //   //     const textResponse = await response.text();
// // // //   //     console.log("Updated Data API Response:", textResponse);

// // // //   //     if (
// // // //   //       textResponse.toLowerCase().includes("deleted") ||
// // // //   //       textResponse.toLowerCase().includes("success") ||
// // // //   //       textResponse.toLowerCase().includes("ok")
// // // //   //     ) {
// // // //   //       toast.success("Fares updated successfully!");
// // // //   //       setTimeout(() => {
// // // //   //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // //   //       }, 1500);
// // // //   //       return;
// // // //   //     }

// // // //   //     let jsonResponse;
// // // //   //     try {
// // // //   //       jsonResponse = JSON.parse(textResponse);
// // // //   //     } catch {
// // // //   //       toast.success("Update successful.");
// // // //   //       setTimeout(() => {
// // // //   //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // //   //       }, 1500);
// // // //   //       return;
// // // //   //     }

// // // //   //     if (jsonResponse?.Response?.[0]?.Status === "Ok") {
// // // //   //       toast.success("Data updated successfully!");
// // // //   //       setTimeout(() => {
// // // //   //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // //   //       }, 1500);
// // // //   //     } else {
// // // //   //       toast.error("Update failed: " + (jsonResponse.message || "Unknown error"));
// // // //   //     }
// // // //   //   } catch (error) {
// // // //   //     console.error("Update Error:", error);
// // // //   //     toast.error("Update failed due to network or server error.");
// // // //   //   }
// // // //   // };



// // // //   const handleSaveChanges = async () => {
// // // //   if (!editableData.ID || !editableData.PackageName) {
// // // //     toast.warn("ID and Package Name are required.");
// // // //     return;
// // // //   }

// // // //   const whereCondition = `ID=${editableData.ID}`;
// // // //   const updateData = new URLSearchParams({
// // // //     SecurityKey: SECURITY_KEY,
// // // //     TableName: "Fares",
// // // //     WhereCondition: whereCondition,
// // // //   });

// // // //   Object.entries(editableData).forEach(([key, value]) => {
// // // //     if (value !== undefined && value !== null && key !== "ID") {
// // // //       updateData.append(key.trim(), value.toString());
// // // //     }
// // // //   });

// // // //   try {
// // // //     // ===== Modified API Connection (with logging) =====
// // // //     const res = await apiWithLog({
// // // //       method: "POST",
// // // //       url: `${BASE_REST_API_URL}/updatedata.aspx`,
// // // //       data: updateData.toString(),
// // // //       module: "Fares",
// // // //       action: "E",
// // // //       headers: {
// // // //         "Content-Type": "application/x-www-form-urlencoded",
// // // //         Accept: "application/json",
// // // //       },
// // // //     });

// // // //     const textResponse =
// // // //       typeof res.data === "string"
// // // //         ? res.data
// // // //         : JSON.stringify(res.data);

// // // //     console.log("Updated Data API Response:", textResponse);

// // // //     if (
// // // //       textResponse.toLowerCase().includes("deleted") ||
// // // //       textResponse.toLowerCase().includes("success") ||
// // // //       textResponse.toLowerCase().includes("ok")
// // // //     ) {
// // // //       toast.success("Fares updated successfully!");
// // // //       setTimeout(() => {
// // // //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // //       }, 1500);
// // // //       return;
// // // //     }

// // // //     let jsonResponse;
// // // //     try {
// // // //       jsonResponse = JSON.parse(textResponse);
// // // //     } catch {
// // // //       toast.success("Update successful.");
// // // //       setTimeout(() => {
// // // //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // //       }, 1500);
// // // //       return;
// // // //     }

// // // //     if (jsonResponse?.Response?.[0]?.Status === "Ok") {
// // // //       toast.success("Data updated successfully!");
// // // //       setTimeout(() => {
// // // //         navigate("/showfares", { state: { updatedItem: editableData } });
// // // //       }, 1500);
// // // //     } else {
// // // //       toast.error(
// // // //         "Update failed: " + (jsonResponse.message || "Unknown error")
// // // //       );
// // // //     }
// // // //   } catch (error) {
// // // //     console.error("Update Error:", error);
// // // //     toast.error("Update failed due to network or server error.");
// // // //   }
// // // // };



// // // //   return (
// // // //     <div className="compney_container mb-5">
// // // //       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
// // // //       <form className="compney_form">
// // // //         <h5 className="text-center font-bold m-3">Update Fares</h5>

// // // //         {/* Hidden ID */}
// // // //         <div className="compney_input_div d-none">
// // // //           <input type="text" name="ID" value={editableData.ID || ""} readOnly />
// // // //         </div>

// // // //         <div className="compney_input_div">
// // // //                     whiteSpace: "nowrap",
// // // //                     height: "32px",
// // // //                     display: "inline-flex",
// // // //                     alignItems: "center",
// // // //                     justifyContent: "center",
// // // //                     flexShrink: 0,
// // // //                     boxSizing: "border-box",
// // // //                   }}
// // // //                 >
// // // //                   📋 List
// // // //                 </button>
// // // //               </>
// // // //             )}
// // // //           </div>
// // // //         </div>

// // // //         <div className="compney_input_div">
// // // //           <label>Base Fare</label>
// // // //           <input
// // // //             type="number"
// // // //             name="BaseFare"
// // // //             value={editableData.BaseFare || ""}
// // // //             onChange={handleInputChange}
// // // //             placeholder="Enter Base Fare"
// // // //             required
// // // //           />
// // // //         </div>

// // // //         <div className="compney_input_div">
// // // //           <label>Fuel Rate per KM</label>
// // // //           <input
// // // //             type="number"
// // // //             name="FuelRateKM"
// // // //             value={editableData.FuelRateKM || ""}
// // // //             onChange={handleInputChange}
// // // //             placeholder="Enter Fuel Rate per KM"
// // // //             required
// // // //           />
// // // //         </div>

// // // //         <div className="compney_input_div">
// // // //           <label>Lub Rate per KM</label>
// // // //           <input
// // // //             type="number"
// // // //             name="LubRateKM"
// // // //             value={editableData.LubRateKM || ""}
// // // //             onChange={handleInputChange}
// // // //             placeholder="Enter Lub Rate per KM"
// // // //             required
// // // //           />
// // // //         </div>

// // // //         <div className="compney_input_div">
// // // //           <label>Time Rate per Minute</label>
// // // //           <input
// // // //             type="number"
// // // //             name="TimeRatePM"
// // // //             value={editableData.TimeRatePM || ""}
// // // //             onChange={handleInputChange}
// // // //             placeholder="Enter Time Rate per Minute"
// // // //             required
// // // //           />
// // // //         </div>

// // // //         <div className="compney_input_div">
// // // //           <label>Included KM</label>
// // // //           <input
// // // //             type="number"
// // // //             name="IncludedKM"
// // // //             value={editableData.IncludedKM || ""}
// // // //             onChange={handleInputChange}
// // // //             placeholder="Enter Included KM"
// // // //             required
// // // //           />
// // // //         </div>

// // // //         <div className="compney_input_div">
// // // //           <label>Included Hours</label>
// // // //           <input
// // // //             type="number"
// // // //             name="IncludedHrs"
// // // //             value={editableData.IncludedHrs || ""}
// // // //             onChange={handleInputChange}
// // // //             placeholder="Enter Included Hours"
// // // //             required
// // // //           />
// // // //         </div>

// // // //         <div className="compney_input_div">
// // // //           <label>Vehicle Type (Vtype)</label>
// // // //           <select
// // // //             id="vtype"
// // // //             name="Vtype"
// // // //             value={editableData.Vtype?.toString() || ""}
// // // //             onChange={handleInputChange}
// // // //             required
// // // //           >
// // // //             <option value="">Select Vehicle Type</option>
// // // //             {vehicleTypeList.map((type) => (
// // // //               <option key={type.ID} value={type.ID}>
// // // //                 {type.VTYPE}
// // // //               </option>
// // // //             ))}
// // // //           </select>
// // // //         </div>

// // // //         <button
// // // //           type="button"
// // // //           className="save-changebtn"
// // // //           onClick={handleSaveChanges}
// // // //         >
// // // //           Save Changes
// // // //         </button>
// // // //       </form>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default Updatefares;
// // // import React, { useState, useEffect } from "react";
// // // import { useLocation, useNavigate } from "react-router-dom";
// // // import { toast, ToastContainer } from "react-toastify";
// // // import "react-toastify/dist/ReactToastify.css";
// // // import { SECURITY_KEY } from "../../../globals";
// // // import { apiWithLog } from "../../../utils/apiWithLog";

// // // const Updatefares = () => {
// // //   const location = useLocation();
// // //   const navigate = useNavigate();
// // //   const initialData = location.state?.responseData || {};
// // //   const [editableData, setEditableData] = useState(initialData);
// // //   const [vehicleTypeList, setVehicleTypeList] = useState([]);
// // //   const [loading, setLoading] = useState(false);
// // //   const [error, setError] = useState(null);

// // //   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;

// // //   const [existingFaresList, setExistingFaresList] = useState([]);
// // //   const [packageNamesList, setPackageNamesList] = useState([]);

// // //   const compID =
// // //     editableData.CompID || JSON.parse(localStorage.getItem("selectedCompany"))?.id;

// // //   useEffect(() => {
// // //     fetchVehicleTypes();
// // //     fetchExistingFares();
// // //     // eslint-disable-next-line react-hooks/exhaustive-deps
// // //   }, []);

// // //   const fetchExistingFares = async () => {
// // //     try {
// // //       const data = new URLSearchParams();
// // //       data.append("SecurityKey", SECURITY_KEY);
// // //       data.append("TableName", "Fares");
// // //       data.append("WhereCondition", compID ? `CompID=${compID}` : "All");
// // //       data.append("*", "*");

// // //       const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
// // //       const response = await fetch(apiUrl, {
// // //         method: "POST",
// // //         headers: { "Content-Type": "application/x-www-form-urlencoded" },
// // //         body: data.toString(),
// // //       });

// // //       const jsonData = await response.json();
// // //       if (Array.isArray(jsonData.Response)) {
// // //         setExistingFaresList(jsonData.Response);
// // //         const uniqueNames = Array.from(
// // //           new Set(
// // //             jsonData.Response.map((f) => (f.PackageName || "").trim()).filter(Boolean)
// // //           )
// // //         ).sort();
// // //         setPackageNamesList(uniqueNames);
// // //       } else {
// // //         setExistingFaresList([]);
// // //         setPackageNamesList([]);
// // //       }
// // //     } catch (err) {
// // //       console.error("Failed to fetch existing fares:", err);
// // //     }
// // //   };

// // //   const fetchVehicleTypes = async () => {
// // //     setError(null);
// // //     setLoading(true);
// // //     setVehicleTypeList([]);

// // //     const data = new URLSearchParams();
// // //     data.append("SecurityKey", SECURITY_KEY);
// // //     data.append("TableName", "VehicleTypes");
// // //     data.append("WhereCondition", "All");
// // //     data.append("*", "*");

// // //     try {
// // //       const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
// // //       const response = await fetch(apiUrl, {
// // //         method: "POST",
// // //         headers: { "Content-Type": "application/x-www-form-urlencoded" },
// // //         body: data.toString(),
// // //       });

// // //       const textData = await response.text();
// // //       let jsonData;
// // //       try {
// // //         jsonData = JSON.parse(textData);
// // //       } catch (err) {
// // //         console.error("Vehicle Type JSON Parse Error:", err);
// // //         jsonData = null;
// // //       }

// // //       if (jsonData && Array.isArray(jsonData.Response)) {
// // //         setVehicleTypeList(jsonData.Response);
// // //       } else {
// // //         setError("No vehicle type data found.");
// // //       }
// // //     } catch (err) {
// // //       console.error("Vehicle Type Fetch Error:", err);
// // //       setError("Failed to fetch vehicle types.");
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const handleInputChange = (e) => {
// // //     const { name, value } = e.target;
// // //     setEditableData((prev) => ({ ...prev, [name]: value }));
// // //   };

// // //   // Package name is unique per company (CompID). Own record (same ID) is excluded
// // //   // from the check so re-saving a fare under its existing name is allowed.
// // //   const isDuplicatePackageName = (name) => {
// // //     const normalized = name.trim().toLowerCase();
// // //     return existingFaresList.some(
// // //       (f) =>
// // //         String(f.ID) !== String(editableData.ID) &&
// // //         (f.PackageName || "").trim().toLowerCase() === normalized
// // //     );
// // //   };

// // //   const handleSaveChanges = async () => {
// // //     const packageName = (editableData.PackageName || "").trim();

// // //     if (!editableData.ID || !packageName) {
// // //       toast.warn("ID and Package Name are required.");
// // //       return;
// // //     }

// // //     if (isDuplicatePackageName(packageName)) {
// // //       toast.error("A package with this name already exists for this company.");
// // //       return;
// // //     }

// // //     const whereCondition = `ID=${editableData.ID}`;
// // //     const updateData = new URLSearchParams({
// // //       SecurityKey: SECURITY_KEY,
// // //       TableName: "Fares",
// // //       WhereCondition: whereCondition,
// // //     });

// // //     Object.entries({ ...editableData, PackageName: packageName }).forEach(
// // //       ([key, value]) => {
// // //         if (value !== undefined && value !== null && key !== "ID") {
// // //           updateData.append(key.trim(), value.toString());
// // //         }
// // //       }
// // //     );

// // //     try {
// // //       const res = await apiWithLog({
// // //         method: "POST",
// // //         url: `${BASE_REST_API_URL}/updatedata.aspx`,
// // //         data: updateData.toString(),
// // //         module: "Fares",
// // //         action: "E",
// // //         headers: {
// // //           "Content-Type": "application/x-www-form-urlencoded",
// // //           Accept: "application/json",
// // //         },
// // //       });

// // //       const textResponse =
// // //         typeof res.data === "string" ? res.data : JSON.stringify(res.data);

// // //       if (
// // //         textResponse.toLowerCase().includes("deleted") ||
// // //         textResponse.toLowerCase().includes("success") ||
// // //         textResponse.toLowerCase().includes("ok")
// // //       ) {
// // //         toast.success("Fares updated successfully!");
// // //         setTimeout(() => {
// // //           navigate("/showfares", { state: { updatedItem: editableData } });
// // //         }, 1500);
// // //         return;
// // //       }

// // //       let jsonResponse;
// // //       try {
// // //         jsonResponse = JSON.parse(textResponse);
// // //       } catch {
// // //         toast.success("Update successful.");
// // //         setTimeout(() => {
// // //           navigate("/showfares", { state: { updatedItem: editableData } });
// // //         }, 1500);
// // //         return;
// // //       }

// // //       if (jsonResponse?.Response?.[0]?.Status === "Ok") {
// // //         toast.success("Data updated successfully!");
// // //         setTimeout(() => {
// // //           navigate("/showfares", { state: { updatedItem: editableData } });
// // //         }, 1500);
// // //       } else {
// // //         toast.error(
// // //           "Update failed: " + (jsonResponse.message || "Unknown error")
// // //         );
// // //       }
// // //     } catch (err) {
// // //       console.error("Update Error:", err);
// // //       toast.error("Update failed due to network or server error.");
// // //     }
// // //   };

// // //   return (
// // //     <div className="compney_container mb-5">
// // //       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
// // //       <form className="compney_form">
// // //         <h5 className="text-center font-bold m-3">Update Fares</h5>

// // //         <div className="compney_input_div d-none">
// // //           <input type="text" name="ID" value={editableData.ID || ""} readOnly />
// // //         </div>

// // //         <div className="compney_input_div">
// // //           <label>Package Name</label>
// // //           <input
// // //             type="text"
// // //             name="PackageName"
// // //             list="package-names"
// // //             value={editableData.PackageName || ""}
// // //             onChange={handleInputChange}
// // //             placeholder="Enter Package Name"
// // //             autoComplete="off"
// // //             required
// // //           />
// // //           <datalist id="package-names">
// // //             {packageNamesList.map((name, idx) => (
// // //               <option key={idx} value={name} />
// // //             ))}
// // //           </datalist>
// // //         </div>

// // //         <div className="compney_input_div">
// // //           <label>Base Fare</label>
// // //           <input
// // //             type="number"
// // //             name="BaseFare"
// // //             value={editableData.BaseFare || ""}
// // //             onChange={handleInputChange}
// // //             placeholder="Enter Base Fare"
// // //             required
// // //           />
// // //         </div>

// // //         <div className="compney_input_div">
// // //           <label>Fuel Rate per KM</label>
// // //           <input
// // //             type="number"
// // //             name="FuelRateKM"
// // //             value={editableData.FuelRateKM || ""}
// // //             onChange={handleInputChange}
// // //             placeholder="Enter Fuel Rate per KM"
// // //             required
// // //           />
// // //         </div>

// // //         <div className="compney_input_div">
// // //           <label>Lub Rate per KM</label>
// // //           <input
// // //             type="number"
// // //             name="LubRateKM"
// // //             value={editableData.LubRateKM || ""}
// // //             onChange={handleInputChange}
// // //             placeholder="Enter Lub Rate per KM"
// // //             required
// // //           />
// // //         </div>

// // //         <div className="compney_input_div">
// // //           <label>Time Rate per Minute</label>
// // //           <input
// // //             type="number"
// // //             name="TimeRatePM"
// // //             value={editableData.TimeRatePM || ""}
// // //             onChange={handleInputChange}
// // //             placeholder="Enter Time Rate per Minute"
// // //             required
// // //           />
// // //         </div>

// // //         <div className="compney_input_div">
// // //           <label>Included KM</label>
// // //           <input
// // //             type="number"
// // //             name="IncludedKM"
// // //             value={editableData.IncludedKM || ""}
// // //             onChange={handleInputChange}
// // //             placeholder="Enter Included KM"
// // //             required
// // //           />
// // //         </div>

// // //         <div className="compney_input_div">
// // //           <label>Included Hours</label>
// // //           <input
// // //             type="number"
// // //             name="IncludedHrs"
// // //             value={editableData.IncludedHrs || ""}
// // //             onChange={handleInputChange}
// // //             placeholder="Enter Included Hours"
// // //             required
// // //           />
// // //         </div>

// // //         <div className="compney_input_div">
// // //           <label>Vehicle Type (Vtype)</label>
// // //           <select
// // //             id="vtype"
// // //             name="Vtype"
// // //             value={editableData.Vtype?.toString() || ""}
// // //             onChange={handleInputChange}
// // //             required
// // //           >
// // //             <option value="">Select Vehicle Type</option>
// // //             {vehicleTypeList.map((type) => (
// // //               <option key={type.ID} value={type.ID}>
// // //                 {type.VTYPE}
// // //               </option>
// // //             ))}
// // //           </select>
// // //         </div>

// // //         <button type="button" className="save-changebtn" onClick={handleSaveChanges}>
// // //           Save Changes
// // //         </button>
// // //       </form>
// // //     </div>
// // //   );
// // // };

// // // export default Updatefares;

// // import React, { useState, useEffect } from "react";
// // import { useLocation, useNavigate } from "react-router-dom";
// // import { toast, ToastContainer } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import { SECURITY_KEY } from "../../../globals";
// // import { apiWithLog } from "../../../utils/apiWithLog";

// // const ADD_NEW_VALUE = "__ADD_NEW__";

// // const Updatefares = () => {
// //   const location = useLocation();
// //   const navigate = useNavigate();
// //   const initialData = location.state?.responseData || {};
// //   const [editableData, setEditableData] = useState(initialData);
// //   const [vehicleTypeList, setVehicleTypeList] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [error, setError] = useState(null);

// //   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;

// //   const [existingFaresList, setExistingFaresList] = useState([]);
// //   const [packageNamesList, setPackageNamesList] = useState([]);
// //   const [isCustomPackage, setIsCustomPackage] = useState(false);

// //   const compID =
// //     editableData.CompID || JSON.parse(localStorage.getItem("selectedCompany"))?.id;

// //   useEffect(() => {
// //     fetchVehicleTypes();
// //     fetchExistingFares();
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   const fetchExistingFares = async () => {
// //     try {
// //       const data = new URLSearchParams();
// //       data.append("SecurityKey", SECURITY_KEY);
// //       data.append("TableName", "Fares");
// //       data.append("WhereCondition", compID ? `CompID=${compID}` : "All");
// //       data.append("*", "*");

// //       const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
// //       const response = await fetch(apiUrl, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/x-www-form-urlencoded" },
// //         body: data.toString(),
// //       });

// //       const jsonData = await response.json();
// //       if (Array.isArray(jsonData.Response)) {
// //         setExistingFaresList(jsonData.Response);
// //         const uniqueNames = Array.from(
// //           new Set(
// //             jsonData.Response.map((f) => (f.PackageName || "").trim()).filter(Boolean)
// //           )
// //         ).sort();
// //         setPackageNamesList(uniqueNames);
// //       } else {
// //         setExistingFaresList([]);
// //         setPackageNamesList([]);
// //       }
// //     } catch (err) {
// //       console.error("Failed to fetch existing fares:", err);
// //     }
// //   };

// //   const fetchVehicleTypes = async () => {
// //     setError(null);
// //     setLoading(true);
// //     setVehicleTypeList([]);

// //     const data = new URLSearchParams();
// //     data.append("SecurityKey", SECURITY_KEY);
// //     data.append("TableName", "VehicleTypes");
// //     data.append("WhereCondition", "All");
// //     data.append("*", "*");

// //     try {
// //       const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
// //       const response = await fetch(apiUrl, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/x-www-form-urlencoded" },
// //         body: data.toString(),
// //       });

// //       const textData = await response.text();
// //       let jsonData;
// //       try {
// //         jsonData = JSON.parse(textData);
// //       } catch (err) {
// //         console.error("Vehicle Type JSON Parse Error:", err);
// //         jsonData = null;
// //       }

// //       if (jsonData && Array.isArray(jsonData.Response)) {
// //         setVehicleTypeList(jsonData.Response);
// //       } else {
// //         setError("No vehicle type data found.");
// //       }
// //     } catch (err) {
// //       console.error("Vehicle Type Fetch Error:", err);
// //       setError("Failed to fetch vehicle types.");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const handleInputChange = (e) => {
// //     const { name, value } = e.target;
// //     setEditableData((prev) => ({ ...prev, [name]: value }));
// //   };

// //   // Dropdown selection: either pick an existing package (auto-fills its rates)
// //   // or switch to "Add New" which reveals a free-text input.
// //   const handlePackageSelect = (e) => {
// //     const selectedName = e.target.value;

// //     if (selectedName === ADD_NEW_VALUE) {
// //       setIsCustomPackage(true);
// //       setEditableData((prev) => ({ ...prev, PackageName: "" }));
// //       return;
// //     }

// //     const matchingFare = existingFaresList.find(
// //       (f) => (f.PackageName || "").trim().toLowerCase() === selectedName.toLowerCase()
// //     );

// //     setEditableData((prev) => ({
// //       ...prev,
// //       PackageName: selectedName,
// //       BaseFare: matchingFare?.BaseFare ?? prev.BaseFare,
// //       FuelRateKM: matchingFare?.FuelRateKM ?? prev.FuelRateKM,
// //       LubRateKM: matchingFare?.LubRateKM ?? prev.LubRateKM,
// //       TimeRatePM: matchingFare?.TimeRatePM ?? prev.TimeRatePM,
// //       IncludedKM: matchingFare?.IncludedKM ?? prev.IncludedKM,
// //       IncludedHrs: matchingFare?.IncludedHrs ?? prev.IncludedHrs,
// //     }));
// //   };

// //   const handleBackToList = () => {
// //     setIsCustomPackage(false);
// //     setEditableData((prev) => ({ ...prev, PackageName: "" }));
// //   };

// //   // Package name is unique per company (CompID). Own record (same ID) is excluded
// //   // so re-saving a fare under its current name is still allowed.
// //   const isDuplicatePackageName = (name) => {
// //     const normalized = name.trim().toLowerCase();
// //     return existingFaresList.some(
// //       (f) =>
// //         String(f.ID) !== String(editableData.ID) &&
// //         (f.PackageName || "").trim().toLowerCase() === normalized
// //     );
// //   };

// //   const handleSaveChanges = async () => {
// //     const packageName = (editableData.PackageName || "").trim();

// //     if (!editableData.ID || !packageName) {
// //       toast.warn("ID and Package Name are required.");
// //       return;
// //     }

// //     if (isCustomPackage && isDuplicatePackageName(packageName)) {
// //       toast.error("A package with this name already exists for this company.");
// //       return;
// //     }

// //     const whereCondition = `ID=${editableData.ID}`;
// //     const updateData = new URLSearchParams({
// //       SecurityKey: SECURITY_KEY,
// //       TableName: "Fares",
// //       WhereCondition: whereCondition,
// //     });

// //     Object.entries({ ...editableData, PackageName: packageName }).forEach(
// //       ([key, value]) => {
// //         if (value !== undefined && value !== null && key !== "ID") {
// //           updateData.append(key.trim(), value.toString());
// //         }
// //       }
// //     );

// //     try {
// //       const res = await apiWithLog({
// //         method: "POST",
// //         url: `${BASE_REST_API_URL}/updatedata.aspx`,
// //         data: updateData.toString(),
// //         module: "Fares",
// //         action: "E",
// //         headers: {
// //           "Content-Type": "application/x-www-form-urlencoded",
// //           Accept: "application/json",
// //         },
// //       });

// //       const textResponse =
// //         typeof res.data === "string" ? res.data : JSON.stringify(res.data);

// //       if (
// //         textResponse.toLowerCase().includes("deleted") ||
// //         textResponse.toLowerCase().includes("success") ||
// //         textResponse.toLowerCase().includes("ok")
// //       ) {
// //         toast.success("Fares updated successfully!");
// //         setTimeout(() => {
// //           navigate("/showfares", { state: { updatedItem: editableData } });
// //         }, 1500);
// //         return;
// //       }

// //       let jsonResponse;
// //       try {
// //         jsonResponse = JSON.parse(textResponse);
// //       } catch {
// //         toast.success("Update successful.");
// //         setTimeout(() => {
// //           navigate("/showfares", { state: { updatedItem: editableData } });
// //         }, 1500);
// //         return;
// //       }

// //       if (jsonResponse?.Response?.[0]?.Status === "Ok") {
// //         toast.success("Data updated successfully!");
// //         setTimeout(() => {
// //           navigate("/showfares", { state: { updatedItem: editableData } });
// //         }, 1500);
// //       } else {
// //         toast.error(
// //           "Update failed: " + (jsonResponse.message || "Unknown error")
// //         );
// //       }
// //     } catch (err) {
// //       console.error("Update Error:", err);
// //       toast.error("Update failed due to network or server error.");
// //     }
// //   };

// //   return (
// //     <div className="compney_container mb-5">
// //       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
// //       <form className="compney_form">
// //         <h5 className="text-center font-bold m-3">Update Fares</h5>

// //         <div className="compney_input_div d-none">
// //           <input type="text" name="ID" value={editableData.ID || ""} readOnly />
// //         </div>

// //         <div className="compney_input_div">
// //           <label>Package Name</label>
// //           {!isCustomPackage ? (
// //             <select
// //               name="PackageName"
// //               value={editableData.PackageName || ""}
// //               onChange={handlePackageSelect}
// //               required
// //             >
// //               <option value="">-- Select Package --</option>
// //               {packageNamesList.map((name, idx) => (
// //                 <option key={idx} value={name}>
// //                   {name}
// //                 </option>
// //               ))}
// //               <option value={ADD_NEW_VALUE}>+ Add New Package</option>
// //             </select>
// //           ) : (
// //             <div style={{ display: "flex", gap: "6px", width: "60%" }}>
// //               <input
// //                 type="text"
// //                 name="PackageName"
// //                 value={editableData.PackageName || ""}
// //                 onChange={handleInputChange}
// //                 placeholder="Enter New Package Name"
// //                 autoFocus
// //                 required
// //                 style={{ flex: 1 }}
// //               />
// //               <button
// //                 type="button"
// //                 className="package-back-btn"
// //                 onClick={handleBackToList}
// //               >
// //                 Back to List
// //               </button>
// //             </div>
// //           )}
// //         </div>

// //         <div className="compney_input_div">
// //           <label>Base Fare</label>
// //           <input
// //             type="number"
// //             name="BaseFare"
// //             value={editableData.BaseFare || ""}
// //             onChange={handleInputChange}
// //             placeholder="Enter Base Fare"
// //             required
// //           />
// //         </div>

// //         <div className="compney_input_div">
// //           <label>Fuel Rate per KM</label>
// //           <input
// //             type="number"
// //             name="FuelRateKM"
// //             value={editableData.FuelRateKM || ""}
// //             onChange={handleInputChange}
// //             placeholder="Enter Fuel Rate per KM"
// //             required
// //           />
// //         </div>

// //         <div className="compney_input_div">
// //           <label>Lub Rate per KM</label>
// //           <input
// //             type="number"
// //             name="LubRateKM"
// //             value={editableData.LubRateKM || ""}
// //             onChange={handleInputChange}
// //             placeholder="Enter Lub Rate per KM"
// //             required
// //           />
// //         </div>

// //         <div className="compney_input_div">
// //           <label>Time Rate per Minute</label>
// //           <input
// //             type="number"
// //             name="TimeRatePM"
// //             value={editableData.TimeRatePM || ""}
// //             onChange={handleInputChange}
// //             placeholder="Enter Time Rate per Minute"
// //             required
// //           />
// //         </div>

// //         <div className="compney_input_div">
// //           <label>Included KM</label>
// //           <input
// //             type="number"
// //             name="IncludedKM"
// //             value={editableData.IncludedKM || ""}
// //             onChange={handleInputChange}
// //             placeholder="Enter Included KM"
// //             required
// //           />
// //         </div>

// //         <div className="compney_input_div">
// //           <label>Included Hours</label>
// //           <input
// //             type="number"
// //             name="IncludedHrs"
// //             value={editableData.IncludedHrs || ""}
// //             onChange={handleInputChange}
// //             placeholder="Enter Included Hours"
// //             required
// //           />
// //         </div>

// //         <div className="compney_input_div">
// //           <label>Vehicle Type (Vtype)</label>
// //           <select
// //             id="vtype"
// //             name="Vtype"
// //             value={editableData.Vtype?.toString() || ""}
// //             onChange={handleInputChange}
// //             required
// //           >
// //             <option value="">Select Vehicle Type</option>
// //             {vehicleTypeList.map((type) => (
// //               <option key={type.ID} value={type.ID}>
// //                 {type.VTYPE}
// //               </option>
// //             ))}
// //           </select>
// //         </div>

// //         <button type="button" className="save-changebtn" onClick={handleSaveChanges}>
// //           Save Changes
// //         </button>
// //       </form>
// //     </div>
// //   );
// // };

// // export default Updatefares;

// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { SECURITY_KEY } from "../../../globals";
// import { apiWithLog } from "../../../utils/apiWithLog";

// const ADD_NEW_VALUE = "__ADD_NEW__";

// const Updatefares = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const initialData = location.state?.responseData || {};
//   const [editableData, setEditableData] = useState(initialData);
//   const [vehicleTypeList, setVehicleTypeList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;

//   const [existingFaresList, setExistingFaresList] = useState([]);
//   const [packageNamesList, setPackageNamesList] = useState([]);
//   const [isCustomPackage, setIsCustomPackage] = useState(false);

//   const compID =
//     editableData.CompID || JSON.parse(localStorage.getItem("selectedCompany"))?.id;

//   useEffect(() => {
//     fetchVehicleTypes();
//     fetchExistingFares();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const fetchExistingFares = async () => {
//     try {
//       const data = new URLSearchParams();
//       data.append("SecurityKey", SECURITY_KEY);
//       data.append("TableName", "Fares");
//       data.append("WhereCondition", compID ? `CompID=${compID}` : "All");
//       data.append("*", "*");

//       const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         body: data.toString(),
//       });

//       const jsonData = await response.json();
//       if (Array.isArray(jsonData.Response)) {
//         setExistingFaresList(jsonData.Response);
//         const uniqueNames = Array.from(
//           new Set(
//             jsonData.Response.map((f) => (f.PackageName || "").trim()).filter(Boolean)
//           )
//         ).sort();
//         setPackageNamesList(uniqueNames);
//       } else {
//         setExistingFaresList([]);
//         setPackageNamesList([]);
//       }
//     } catch (err) {
//       console.error("Failed to fetch existing fares:", err);
//     }
//   };

//   const fetchVehicleTypes = async () => {
//     setError(null);
//     setLoading(true);
//     setVehicleTypeList([]);

//     const data = new URLSearchParams();
//     data.append("SecurityKey", SECURITY_KEY);
//     data.append("TableName", "VehicleTypes");
//     data.append("WhereCondition", "All");
//     data.append("*", "*");

//     try {
//       const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
//       const response = await fetch(apiUrl, {
//         method: "POST",
//         headers: { "Content-Type": "application/x-www-form-urlencoded" },
//         body: data.toString(),
//       });

//       const textData = await response.text();
//       let jsonData;
//       try {
//         jsonData = JSON.parse(textData);
//       } catch (err) {
//         console.error("Vehicle Type JSON Parse Error:", err);
//         jsonData = null;
//       }

//       if (jsonData && Array.isArray(jsonData.Response)) {
//         setVehicleTypeList(jsonData.Response);
//       } else {
//         setError("No vehicle type data found.");
//       }
//     } catch (err) {
//       console.error("Vehicle Type Fetch Error:", err);
//       setError("Failed to fetch vehicle types.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditableData((prev) => ({ ...prev, [name]: value }));
//   };

//   // Dropdown selection: either pick an existing package (auto-fills its rates)
//   // or switch to "Add New" which reveals a free-text input.
//   const handlePackageSelect = (e) => {
//     const selectedName = e.target.value;

//     if (selectedName === ADD_NEW_VALUE) {
//       setIsCustomPackage(true);
//       setEditableData((prev) => ({ ...prev, PackageName: "" }));
//       return;
//     }

//     const matchingFare = existingFaresList.find(
//       (f) => (f.PackageName || "").trim().toLowerCase() === selectedName.toLowerCase()
//     );

//     setEditableData((prev) => ({
//       ...prev,
//       PackageName: selectedName,
//       BaseFare: matchingFare?.BaseFare ?? prev.BaseFare,
//       FuelRateKM: matchingFare?.FuelRateKM ?? prev.FuelRateKM,
//       LubRateKM: matchingFare?.LubRateKM ?? prev.LubRateKM,
//       TimeRatePM: matchingFare?.TimeRatePM ?? prev.TimeRatePM,
//       IncludedKM: matchingFare?.IncludedKM ?? prev.IncludedKM,
//       IncludedHrs: matchingFare?.IncludedHrs ?? prev.IncludedHrs,
//     }));
//   };

//   const handleBackToList = () => {
//     setIsCustomPackage(false);
//     setEditableData((prev) => ({ ...prev, PackageName: "" }));
//   };

//   // Package name is unique per company (CompID). Own record (same ID) is excluded
//   // so re-saving a fare under its current name is still allowed.
//   const isDuplicatePackageName = (name) => {
//     const normalized = name.trim().toLowerCase();
//     return existingFaresList.some(
//       (f) =>
//         String(f.ID) !== String(editableData.ID) &&
//         (f.PackageName || "").trim().toLowerCase() === normalized
//     );
//   };

//   const handleSaveChanges = async () => {
//     const packageName = (editableData.PackageName || "").trim();

//     if (!editableData.ID || !packageName) {
//       toast.warn("ID and Package Name are required.");
//       return;
//     }

//     if (isCustomPackage && isDuplicatePackageName(packageName)) {
//       toast.error("A package with this name already exists for this company.");
//       return;
//     }

//     const whereCondition = `ID=${editableData.ID}`;
//     const updateData = new URLSearchParams({
//       SecurityKey: SECURITY_KEY,
//       TableName: "Fares",
//       WhereCondition: whereCondition,
//     });

//     Object.entries({ ...editableData, PackageName: packageName }).forEach(
//       ([key, value]) => {
//         if (value !== undefined && value !== null && key !== "ID") {
//           updateData.append(key.trim(), value.toString());
//         }
//       }
//     );

//     try {
//       const res = await apiWithLog({
//         method: "POST",
//         url: `${BASE_REST_API_URL}/updatedata.aspx`,
//         data: updateData.toString(),
//         module: "Fares",
//         action: "E",
//         headers: {
//           "Content-Type": "application/x-www-form-urlencoded",
//           Accept: "application/json",
//         },
//       });

//       const textResponse =
//         typeof res.data === "string" ? res.data : JSON.stringify(res.data);

//       if (
//         textResponse.toLowerCase().includes("deleted") ||
//         textResponse.toLowerCase().includes("success") ||
//         textResponse.toLowerCase().includes("ok")
//       ) {
//         toast.success("Fares updated successfully!");
//         setTimeout(() => {
//           navigate("/showfares", { state: { updatedItem: editableData } });
//         }, 1500);
//         return;
//       }

//       let jsonResponse;
//       try {
//         jsonResponse = JSON.parse(textResponse);
//       } catch {
//         toast.success("Update successful.");
//         setTimeout(() => {
//           navigate("/showfares", { state: { updatedItem: editableData } });
//         }, 1500);
//         return;
//       }

//       if (jsonResponse?.Response?.[0]?.Status === "Ok") {
//         toast.success("Data updated successfully!");
//         setTimeout(() => {
//           navigate("/showfares", { state: { updatedItem: editableData } });
//         }, 1500);
//       } else {
//         toast.error(
//           "Update failed: " + (jsonResponse.message || "Unknown error")
//         );
//       }
//     } catch (err) {
//       console.error("Update Error:", err);
//       toast.error("Update failed due to network or server error.");
//     }
//   };

//   return (
//     <div className="compney_container mb-5">
//       <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
//       <form className="compney_form">
//         <h5 className="text-center font-bold m-3">Update Fares</h5>

//         <div className="compney_input_div d-none">
//           <input type="text" name="ID" value={editableData.ID || ""} readOnly />
//         </div>

//         <div className="compney_input_div">
//           <label>Package Name</label>
//           {!isCustomPackage ? (
//             <select
//               name="PackageName"
//               value={editableData.PackageName || ""}
//               onChange={handlePackageSelect}
//               required
//             >
//               <option value="">-- Select Package --</option>
//               {packageNamesList.map((name, idx) => (
//                 <option key={idx} value={name}>
//                   {name}
//                 </option>
//               ))}
//               <option value={ADD_NEW_VALUE}>+ Add New Package</option>
//             </select>
//           ) : (
//             <div
//               style={{
//                 display: "flex",
//                 gap: "6px",
//                 width: "60%",
//                 alignItems: "center",
//               }}
//             >
//               <input
//                 type="text"
//                 name="PackageName"
//                 value={editableData.PackageName || ""}
//                 onChange={handleInputChange}
//                 placeholder="Enter New Package Name"
//                 autoFocus
//                 required
//                 style={{
//                   flex: 1,
//                   minWidth: 0,
//                   margin: 0,
//                   padding: "5px 8px",
//                   fontSize: "13px",
//                   height: "32px",
//                   boxSizing: "border-box",
//                 }}
//               />
//               <button
//                 type="button"
//                 onClick={handleBackToList}
//                 style={{
//                   backgroundColor: "#0f766e",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: "4px",
//                   padding: "0 12px",
//                   fontWeight: "600",
//                   fontSize: "12px",
//                   cursor: "pointer",
//                   whiteSpace: "nowrap",
//                   height: "32px",
//                   flexShrink: 0,
//                   boxSizing: "border-box",
//                 }}
//               >
//                 Back to List
//               </button>
//             </div>
//           )}
//         </div>

//         <div className="compney_input_div">
//           <label>Base Fare</label>
//           <input
//             type="number"
//             name="BaseFare"
//             value={editableData.BaseFare || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Base Fare"
//             required
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Fuel Rate per KM</label>
//           <input
//             type="number"
//             name="FuelRateKM"
//             value={editableData.FuelRateKM || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Fuel Rate per KM"
//             required
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Lub Rate per KM</label>
//           <input
//             type="number"
//             name="LubRateKM"
//             value={editableData.LubRateKM || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Lub Rate per KM"
//             required
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Time Rate per Minute</label>
//           <input
//             type="number"
//             name="TimeRatePM"
//             value={editableData.TimeRatePM || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Time Rate per Minute"
//             required
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Included KM</label>
//           <input
//             type="number"
//             name="IncludedKM"
//             value={editableData.IncludedKM || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Included KM"
//             required
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Included Hours</label>
//           <input
//             type="number"
//             name="IncludedHrs"
//             value={editableData.IncludedHrs || ""}
//             onChange={handleInputChange}
//             placeholder="Enter Included Hours"
//             required
//           />
//         </div>

//         <div className="compney_input_div">
//           <label>Vehicle Type (Vtype)</label>
//           <select
//             id="vtype"
//             name="Vtype"
//             value={editableData.Vtype?.toString() || ""}
//             onChange={handleInputChange}
//             required
//           >
//             <option value="">Select Vehicle Type</option>
//             {vehicleTypeList.map((type) => (
//               <option key={type.ID} value={type.ID}>
//                 {type.VTYPE}
//               </option>
//             ))}
//           </select>
//         </div>

//         <button type="button" className="save-changebtn" onClick={handleSaveChanges}>
//           Save Changes
//         </button>
//       </form>
//     </div>
//   );
// };

// export default Updatefares;

import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import { SECURITY_KEY } from "../../../globals";
import { apiWithLog } from "../../../utils/apiWithLog";

const ADD_NEW_VALUE = "__ADD_NEW__";

const Updatefares = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialData = location.state?.responseData || {};
  const [editableData, setEditableData] = useState(initialData);
  const [vehicleTypeList, setVehicleTypeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;

  const [existingFaresList, setExistingFaresList] = useState([]);
  const [packageNamesList, setPackageNamesList] = useState([]);
  const [isCustomPackage, setIsCustomPackage] = useState(false);

  const compID =
    editableData.CompID || JSON.parse(localStorage.getItem("selectedCompany"))?.id;

  useEffect(() => {
    fetchVehicleTypes();
    fetchExistingFares();
  }, []);

  const fetchExistingFares = async () => {
    try {
      const compID = editableData.CompID || JSON.parse(localStorage.getItem("selectedCompany"))?.id;
      const data = new URLSearchParams();
      data.append("SecurityKey", SECURITY_KEY);
      data.append("TableName", "Fares");
      data.append("WhereCondition", compID ? `CompID=${compID}` : "All");
      data.append("*", "*");

      const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });

      const jsonData = await response.json();
      if (Array.isArray(jsonData.Response)) {
        setExistingFaresList(jsonData.Response);
        const uniqueNames = Array.from(
          new Set(
            jsonData.Response.map((f) => (f.PackageName || "").trim()).filter(Boolean)
          )
        ).sort();
        setPackageNamesList(uniqueNames);
      } else {
        setExistingFaresList([]);
        setPackageNamesList([]);
      }
    } catch (err) {
      console.error("Failed to fetch existing fares:", err);
    }
  };

  const fetchVehicleTypes = async () => {
    setError(null);
    setLoading(true);
    setVehicleTypeList([]);

    const data = new URLSearchParams();
    data.append("SecurityKey", SECURITY_KEY);
    data.append("TableName", "VehicleTypes");
    data.append("WhereCondition", "All");
    data.append("*", "*");

    try {
      const apiUrl = `${BASE_REST_API_URL}/SelectData.aspx`;
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });

      const textData = await response.text();
      let jsonData;
      try {
        jsonData = JSON.parse(textData);
      } catch (err) {
        console.error("Vehicle Type JSON Parse Error:", err);
        jsonData = null;
      }

      if (jsonData && Array.isArray(jsonData.Response)) {
        setVehicleTypeList(jsonData.Response);
      } else {
        setError("No vehicle type data found.");
      }
    } catch (err) {
      console.error("Vehicle Type Fetch Error:", err);
      setError("Failed to fetch vehicle types.");
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditableData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePackageSelect = (e) => {
    const selectedName = e.target.value;
    if (selectedName === "__ADD_NEW__") {
      setIsCustomPackage(true);
      setEditableData((prev) => ({ ...prev, PackageName: "" }));
      return;
    }

    setEditableData((prev) => ({
      ...prev,
      PackageName: selectedName,
    }));

    const matchingFare = existingFaresList.find(
      (f) => (f.PackageName || "").trim().toLowerCase() === selectedName.trim().toLowerCase()
    );

    if (matchingFare) {
      setEditableData((prev) => ({
        ...prev,
        PackageName: selectedName,
        BaseFare: matchingFare.BaseFare != null ? matchingFare.BaseFare : prev.BaseFare,
        FuelRateKM: matchingFare.FuelRateKM != null ? matchingFare.FuelRateKM : prev.FuelRateKM,
        LubRateKM: matchingFare.LubRateKM != null ? matchingFare.LubRateKM : prev.LubRateKM,
        TimeRatePM: matchingFare.TimeRatePM != null ? matchingFare.TimeRatePM : prev.TimeRatePM,
        IncludedKM: matchingFare.IncludedKM != null ? matchingFare.IncludedKM : prev.IncludedKM,
        IncludedHrs: matchingFare.IncludedHrs != null ? matchingFare.IncludedHrs : prev.IncludedHrs,
      }));
    }
  };

  const handleBackToList = () => {
    setIsCustomPackage(false);
    setEditableData((prev) => ({ ...prev, PackageName: "" }));
  };

  // Package name is unique per company (CompID). Own record (same ID) is excluded
  // so re-saving a fare under its current name is still allowed.
  const isDuplicatePackageName = (name) => {
    const normalized = (name || "").trim().toLowerCase();
    return existingFaresList.some(
      (f) =>
        String(f.ID) !== String(editableData.ID) &&
        (f.PackageName || "").trim().toLowerCase() === normalized
    );
  };

  const handleSaveChanges = async () => {
    if (loading) return;
    const packageName = (editableData.PackageName || "").trim();

    if (!editableData.ID || !packageName) {
      showToast.warn("ID and Package Name are required.");
      return;
    }

    if (isDuplicatePackageName(packageName)) {
      showToast.error(`Package '${packageName}' already exists!`);
      return;
    }

    const whereCondition = `ID=${editableData.ID}`;
    const updateData = new URLSearchParams({
      SecurityKey: SECURITY_KEY,
      TableName: "Fares",
      WhereCondition: whereCondition,
    });

    Object.entries({ ...editableData, PackageName: packageName }).forEach(
      ([key, value]) => {
        if (value !== undefined && value !== null && key !== "ID") {
          updateData.append(key.trim(), value.toString());
        }
      }
    );

    try {
      setLoading(true);
      const res = await apiWithLog({
        method: "POST",
        url: `${BASE_REST_API_URL}/updatedata.aspx`,
        data: updateData.toString(),
        module: "Fares",
        action: "E",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: "application/json",
        },
      });

      const textResponse =
        typeof res.data === "string" ? res.data : JSON.stringify(res.data);

      if (
        textResponse.toLowerCase().includes("unique key") ||
        textResponse.toLowerCase().includes("duplicate") ||
        textResponse.includes("2627")
      ) {
        showToast.error("Database Error: This package is already assigned to this car!");
        return;
      }

      if (
        textResponse.toLowerCase().includes("deleted") ||
        textResponse.toLowerCase().includes("success") ||
        textResponse.toLowerCase().includes("ok")
      ) {
        showToast.save("Package updated successfully!");
        setTimeout(() => {
          navigate("/showfares", { state: { updatedItem: editableData } });
        }, 1200);
        return;
      }

      let jsonResponse;
      try {
        jsonResponse = JSON.parse(textResponse);
      } catch {
        showToast.save("Update successful.");
        setTimeout(() => {
          navigate("/showfares", { state: { updatedItem: editableData } });
        }, 1200);
        return;
      }

      if (jsonResponse?.Response?.[0]?.Status === "Ok") {
        showToast.save("Data updated successfully!");
        setTimeout(() => {
          navigate("/showfares", { state: { updatedItem: editableData } });
        }, 1200);
      } else {
        showToast.error(
          "Update failed: " + (jsonResponse.message || "Unknown error")
        );
      }
    } catch (err) {
      console.error("Update Error:", err);
      showToast.error("Update failed due to network or server error.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="compney_container mb-5">
      <form className="compney_form">
        <h5 className="text-center font-bold m-3">Update Package</h5>

        <div className="compney_input_div d-none">
          <input type="text" name="ID" value={editableData.ID || ""} readOnly />
        </div>

        <div className="compney_input_div">
          <label style={{ display: "flex", flexDirection: "column" }}>
            <span>Package Name</span>
            {isCustomPackage && packageNamesList.length > 0 && (
              <span
                onClick={() => {
                  setIsCustomPackage(false);
                  setEditableData((prev) => ({ ...prev, PackageName: "" }));
                }}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "4px",
                  fontSize: "11px",
                  color: "#0f766e",
                  cursor: "pointer",
                  fontWeight: "600",
                  marginTop: "3px",
                  textDecoration: "none",
                }}
                title="Return to package list dropdown"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M19 12H5M12 19l-7-7 7-7"/>
                </svg>
                Select Existing Package
              </span>
            )}
          </label>

          {!isCustomPackage && packageNamesList.length > 0 ? (
            <select
              name="PackageName"
              value={editableData.PackageName || ""}
              onChange={handlePackageSelect}
              required
            >
              <option value="">-- Select Package --</option>
              {packageNamesList.map((name, idx) => (
                <option key={idx} value={name}>
                  {name}
                </option>
              ))}
              <option value="__ADD_NEW__">Add New Package...</option>
            </select>
          ) : (
            <input
              type="text"
              name="PackageName"
              value={editableData.PackageName || ""}
              onChange={handleInputChange}
              placeholder="Enter Package Name"
              required
              autoFocus={isCustomPackage}
            />
          )}
        </div>
        {/* Package Section */}
        <div className="uf-section-group uf-section-base">
          <div className="uf-section-label uf-label-base">INCLUDED PACKAGE</div>
          <div className="compney_input_div">
            <label>Base Fare</label>
            <input
              type="number"
              name="BaseFare"
              value={editableData.BaseFare || ""}
              onChange={handleInputChange}
              placeholder="Enter Base Fare"
              required
            />
          </div>

          <div className="compney_input_div">
            <label>Included Hours</label>
            <input
              type="number"
              name="IncludedHrs"
              value={editableData.IncludedHrs || ""}
              onChange={handleInputChange}
              placeholder="Enter Included Hours"
              required
            />
          </div>

          <div className="compney_input_div">
            <label>Included KM</label>
            <input
              type="number"
              name="IncludedKM"
              value={editableData.IncludedKM || ""}
              onChange={handleInputChange}
              placeholder="Enter Included KM"
              required
            />
          </div>
        </div>

        {/* Extra Charges Section */}
        <div className="uf-section-group uf-section-extra">
          <div className="uf-section-label uf-label-extra">ADDITIONAL RATES (EXTRA)</div>
          <div className="compney_input_div">
            <label>Fuel Rate per KM</label>
            <input
              type="number"
              name="FuelRateKM"
              value={editableData.FuelRateKM || ""}
              onChange={handleInputChange}
              placeholder="Enter Fuel Rate per KM"
              required
            />
          </div>

          <div className="compney_input_div">
            <label>Lub Rate per KM</label>
            <input
              type="number"
              name="LubRateKM"
              value={editableData.LubRateKM || ""}
              onChange={handleInputChange}
              placeholder="Enter Lub Rate per KM"
              required
            />
          </div>

          <div className="compney_input_div">
            <label>Time Rate per Hour</label>
            <input
              type="number"
              name="TimeRatePM"
              value={editableData.TimeRatePM || ""}
              onChange={handleInputChange}
              placeholder="Enter Time Rate per Hour"
              required
            />
          </div>
        </div>

        <button type="button" className="save-changebtn" onClick={handleSaveChanges} disabled={loading}>
          {loading ? "Saving Changes..." : "Save Changes"}
        </button>
      </form>
    </div>
  );
};

export default Updatefares;